<template>
  <div style="text-align: center;">
    <img src="../assets/images/no-data.png">
    <div style="margin-top: 10px;">暂无数据</div>
  </div>
</template>

<script>
export default {
  name: "NoData"
}
</script>

<style scoped>

</style>